import React, { useState } from "react";
import styles from "./AIButton.module.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { BsStars } from "react-icons/bs";

function AIButton(props) {
  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");

  /*
    AIボタン押下時
    - 質問文作成
    - API呼び出し
    - 回答を表示
  */
  const callAI = async () => {
    setOpen(true);
    setResponse("問い合わせ中...");

    // 完了したタスク
    const completedTasks = props.todos
      .filter((todo) => todo.isCompleted)
      .map((todo) => `- ${todo.text}`)
      .join("\n");
    const completedTasksText = `完了したタスクは以下です。\n${completedTasks}`

    // 未完了のタスク
    const incompleteTasks = props.todos
      .filter((todo) => !todo.isCompleted)
      .map((todo) => `- ${todo.text}`)
      .join("\n");
    const incompleteTasksText = `未完了のタスクは以下です。\n${incompleteTasks}`

    //　質問文
    const question = "この中から最優先で取りかかるべきタスクを1つ選び、理由も添えて100文字程度の日本語で説明してください。なお、未完了のタスクがない場合、タスクの作成方法のアドバイスをしてください。"
    const prompt = `${completedTasksText}\n${incompleteTasksText}\n\n${question}`;

    // API呼び出し
    const result = await callAIChatGPT(prompt);
    setResponse(result);
  };

  /*
    OpenAI呼び出し
    - 回答を返す
  */
  const callAIChatGPT = async (prompt) => {
    try {

      // APIKeyが未入力の場合
      if (props.apiKey === "") {
        throw new Error("API Keyが未入力です。");
      }
      const apiResponse = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${props.apiKey}`,
        },
        body: JSON.stringify({
          model: "gpt-4",
          messages: [
            {
              role: "user",
              content: prompt,
            },
          ],
        }),
      });

      // エラー処理
      if (!apiResponse.ok) {
        // ステータスコードに応じたメッセージを表示
        if (apiResponse.status === 401) {
          throw new Error("APIキーが無効です（401 Unauthorized）");
        } else if (apiResponse.status === 429) {
          throw new Error("リクエスト数が制限を超えました（429 Too Many Requests）");
        } else if (apiResponse.status === 403) {
          throw new Error("アクセス権限がありません（403 Forbidden）");
        } else {
          throw new Error(`${apiResponse.status}`);
        }
      }

      // 回答を返す
      const data = await apiResponse.json();
      return data.choices?.[0]?.message?.content || "AIからの返答が取得できませんでした。"

    } catch (error) {
      return `エラーが発生しました。${error.message}`
    }
  };

  // モーダルを閉じる
  const closeDialog = () => setOpen(false);

  return (
    <>
      <Button color="primary" id="AI" onClick={callAI}><BsStars />AI</Button>

      <Modal isOpen={open} toggle={closeDialog} className={styles.modalCentered}>
        <ModalHeader toggle={closeDialog}>AIに問い合わせ</ModalHeader>
        <ModalBody className={styles.modalBody} >{response}</ModalBody>
        <ModalFooter>
          <Button onClick={closeDialog}>Close</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AIButton;